import * as React from 'react';
/**
 * @ignore - internal component.
 */
const ToggleButtonGroupContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ToggleButtonGroupContext.displayName = 'ToggleButtonGroupContext';
}
export default ToggleButtonGroupContext;